import { render, staticRenderFns } from "./EmployerOtherAgeRequirementSelect.vue?vue&type=template&id=1f1630f7&"
import script from "./EmployerOtherAgeRequirementSelect.vue?vue&type=script&lang=js&"
export * from "./EmployerOtherAgeRequirementSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports